module.exports = __webpack_public_path__ + "static/media/ai-ad-elsayed.ca0e9e05.mp4";